import { React, useState, useEffect } from 'react'
import SVGIcon from 'reusableComponents/SVGIcon'
import { ReactComponent as CircleCheck } from 'assets/svg/circle-check.svg'
import { colors } from 'globalStyles'
import PropTypes from 'prop-types'

/*
Relative Sizing 	Equivalent in Pixels
2xs		            10px
xs		            12px
sm	          	  14px
lg	          	  20px
xl	          	  24px
2xl	        	    32px
*/

const CheckMark = ({ color, size, style, delay, onComplete }) => {
  const [showIcon, setShowIcon] = useState(true)

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowIcon(false)
      onComplete(true)
    }, delay)
    return () => {
      clearTimeout(timer)
    }
  }, [delay, onComplete])

  return showIcon && <SVGIcon Icon={CircleCheck} color={color} size={size} style={style} />
}

CheckMark.defaultProps = {
  color: colors.primary_blue,
  size: 'xl', // Default size
  style: {},
  delay: 0, // Default delay,
  onComplete: null,
}

CheckMark.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.shape({})]),
  delay: PropTypes.number,
  onComplete: PropTypes.func, // Function to perform some actions when the delay is over
}

export default CheckMark
